<template>
<div >
    <p class="title">企业申报</p>
    <div>
        <p>1、根据企业真实信息依次填写企业基本信息、证书信息、资质信息、人员信息、发票信息，所有信息按要求填写完成并提交后，企业信息完成申报。</p>
        <img src="../assets/help/1.1.1-3.png" alt="">
        <img src="../assets/help/1.1.1-4.png" alt="">
    </div>
</div>
</template>
<script>
export default {
    name:'center',
    data(){
        return{
            
        }

    }
}
</script>
<style>

</style>